module.exports = __webpack_public_path__ + "files/fd19af532a6af9f674cc2d5185de6480.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-72x72.png
// module id = 743
// module chunks = 27